import { useMemo, useState } from 'react';
import EnumerationAuditLogFilter from './EnumerationAuditLogFilter';
import EnumerationAuditLogList from './EnumerationAuditLogList';
import useEnumerationAuditList from './hooks/useEnumerationAuditList';
import Header from '../../common/Header/Header';
import httpheader from 'src/Admin/shared/httpheader';
import CustomClientError from 'src/Admin/errorhandling/CustomClientError';
import { useLocation } from 'react-router-dom';

export const defaultOption = {
  label: 'All',
  value: 'All',
};

const EnumerationAuditLog = () => {
  //const subDomain = httpheader.getSubDomainName();
  //const prefix = subDomain != '' ? '/' + subDomain + '/' : '/';
  const location = useLocation();

  const [filters, setFilters] = useState({
    userid: 'All',
    actiontype: 'All',
    usertype: 'All',
    fromdate: '',
    todate: '',
  });

  const {
    auditData,
    auditDataFetching,
    getAuditListData,
    downloadAuditListData,
    error,
    userOptions,
  } = useEnumerationAuditList(filters);

  const useridOptions = useMemo(() => {
    if (auditDataFetching || !userOptions?.length) {
      return [defaultOption];
    }
    const formatted =
      userOptions?.map((item) => ({
        label: item.UserName,
        value: item.UserID,
      })) || [];
    return [defaultOption, ...formatted];
  }, [auditDataFetching]);

  const searchWithFilters = (isReset = false) => {
    getAuditListData(
      {
        pagenumber: 1,
        pagesize: auditData?.Size || 10,
      },
      isReset,
    );
  };

  return (
    <>
      <div className="container-offset">
        <Header
          linkTo={`/admin/account-unlock`}
          preserveData={{ ...location.state }}
          header="Unlock Account"
        />
      </div>
      <div>
        <EnumerationAuditLogFilter
          filters={filters}
          setFilters={setFilters}
          onSearch={searchWithFilters}
          useridOptions={useridOptions}
          isLoading={auditDataFetching}
        />
      </div>
      <div className="container-offset">
        {!auditDataFetching && (
          <>
            {(error || !auditData?.Response?.length) && (
              <CustomClientError
                CustomClasses="p-0 m-0"
                ErrorHeading="No data found!"
                ErrorMessage="We could not find any data for the selected filter(s)."
              />
            )}
          </>
        )}
        {!error && !!auditData?.Response?.length && (
          <EnumerationAuditLogList
            data={auditData}
            downloadAuditListData={downloadAuditListData}
            getAuditListData={getAuditListData}
            auditDataFetching={auditDataFetching}
          />
        )}
      </div>
    </>
  );
};

export default EnumerationAuditLog;
